/**
 *
 * Asynchronously loads the component for SearchResulView
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
